var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPriority(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1743,
    y1: 456.3983,
    x2: 173.2943,
    y2: 250.1883,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62E1FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A2F3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 118.513,
    cy: 177.863,
    r: 118.513
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.2886,
    y1: 276.3411,
    x2: 116.2986,
    y2: 380.3411,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A2F3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0075CD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M236.476,189.29c-2.313,24.363-12.025,46.581-26.856,64.372 c-5.856,7.029-12.506,13.377-19.825,18.876l-81.83-81.83l-20.585-20.586c-9.12-8.404-14.841-20.452-14.841-33.829 c0-25.391,20.585-45.978,45.978-45.978c13.377,0,25.425,5.722,33.829,14.841L236.476,189.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.4494,
    y1: 222.6014,
    x2: 120.7794,
    y2: 289.9114,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A2F3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0075CD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M209.62,253.662c-5.856,7.029-12.506,13.377-19.825,18.876 c-19.837,14.975-44.524,23.838-71.279,23.838c-3.353,0-6.672-0.135-9.958-0.425l-54.504-54.426 c5.812-26.196,27.179-46.525,53.912-50.816c3.442-0.547,6.962-0.838,10.55-0.838c18.239,0,34.746,7.398,46.692,19.346 L209.62,253.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.8586,
    y1: 399.8911,
    x2: 117.8586,
    y2: 320.4211,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    cx: 118.513,
    cy: 136.29,
    r: 45.978
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.8606,
    y1: 304.3111,
    x2: 117.8606,
    y2: 236.3911,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M182.977,241.526c-16.417,16.641-39.238,26.944-64.462,26.944s-48.045-10.304-64.462-26.944 c6.561-29.56,32.924-51.655,64.462-51.655c18.239,0,34.746,7.398,46.692,19.346C173.924,217.922,180.217,229.065,182.977,241.526z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.0714,
    y1: 456.4029,
    x2: 447.1914,
    y2: 250.1929,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    cx: 393.487,
    cy: 177.863,
    r: 118.513
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.1861,
    y1: 276.3386,
    x2: 390.1961,
    y2: 380.3386,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M511.445,189.29c-2.313,24.363-12.025,46.581-26.856,64.372 c-5.856,7.029-12.506,13.377-19.825,18.876l-81.83-81.83l-20.585-20.586c-9.12-8.404-14.841-20.452-14.841-33.829 c0-25.391,20.585-45.978,45.978-45.978c13.377,0,25.425,5.722,33.829,14.841L511.445,189.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.3461,
    y1: 222.5999,
    x2: 394.6761,
    y2: 289.9099,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M484.59,253.662c-5.856,7.029-12.506,13.377-19.825,18.876 c-19.837,14.975-44.524,23.838-71.279,23.838c-3.353,0-6.672-0.135-9.958-0.425l-54.504-54.426 c5.812-26.196,27.179-46.525,53.912-50.816c3.442-0.547,6.962-0.838,10.55-0.838c18.239,0,34.746,7.398,46.692,19.346 L484.59,253.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.7586,
    y1: 399.8911,
    x2: 391.7586,
    y2: 320.4211,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 393.487,
    cy: 136.29,
    r: 45.978
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.4465,
    y1: 107.749,
    x2: 260.6065,
    y2: 372.599,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M393.485,296.376c26.342,0,50.672-8.599,70.349-23.135l-99.674-99.674 c-21-21.715-48.479-37.116-79.32-43.106c-6.343,14.517-9.869,30.546-9.869,47.401C274.97,243.315,328.03,296.376,393.485,296.376z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.7566,
    y1: 304.3111,
    x2: 391.7566,
    y2: 236.3911,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M457.947,241.526c-16.417,16.641-39.238,26.944-64.462,26.944s-48.045-10.304-64.462-26.944 c6.561-29.56,32.924-51.655,64.462-51.655c18.239,0,34.746,7.398,46.692,19.346C448.895,217.922,455.186,229.065,457.947,241.526z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.5408,
    y1: 217.3033,
    x2: 325.7008,
    y2: 327.1533,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M443.808,253.214l-62.26-62.26c-26.084,4.761-46.813,24.833-52.524,50.572 c16.417,16.641,39.238,26.944,64.462,26.944C412.107,268.471,429.414,262.85,443.808,253.214z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.9786,
    y1: 219.311,
    x2: 398.1586,
    y2: 94.1311,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    cx: 256,
    cy: 278.145,
    r: 150.458
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.8463,
    y1: 160.0088,
    x2: 252.8263,
    y2: 292.0288,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M405.752,292.651c-2.936,30.93-15.266,59.135-34.093,81.721 c-7.434,8.924-15.876,16.983-25.169,23.964L242.607,294.453l-26.134-26.134c-11.577-10.67-18.842-25.963-18.842-42.947 c0-32.235,26.134-58.368,58.369-58.368c16.982,0,32.277,7.264,42.947,18.842L405.752,292.651z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.7288,
    y1: 91.7811,
    x2: 258.5088,
    y2: 177.2311,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M371.659,374.372c-7.434,8.924-15.876,16.983-25.169,23.964 c-25.183,19.011-56.524,30.262-90.489,30.262c-4.257,0-8.47-0.171-12.641-0.539l-69.194-69.095 c7.378-33.256,34.505-59.064,68.442-64.512c4.37-0.696,8.839-1.064,13.393-1.064c23.154,0,44.11,9.392,59.277,24.559 L371.659,374.372z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 316.851,
    x2: 254.8086,
    y2: 215.971,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    cx: 256,
    cy: 225.378,
    r: 58.368
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.1416,
    y1: 54.664,
    x2: 295.2316,
    y2: 104.574,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M200.663,418.093c17.129,6.779,35.797,10.505,55.337,10.505 c43.965,0,83.52-18.861,111.03-48.927l-32.695-32.695c-2.645-3.133-6.421-5.42-11.091-6.099l-14.757-2.144l-38.848-38.762 c-7.985-9.441-23.843-8.197-29.738,3.747l-11.627,23.561c-2.615,5.299-7.67,8.971-13.517,9.82l-26.001,3.778 c-14.725,2.139-20.604,20.235-9.949,30.621l1.353,1.319c0.236,0.256,0.472,0.512,0.726,0.76l1.354,1.32 c0.235,0.256,0.471,0.512,0.725,0.759l1.354,1.32c0.235,0.256,0.471,0.512,0.725,0.759l1.354,1.32 c0.235,0.256,0.471,0.512,0.725,0.759l1.354,1.32c0.235,0.256,0.471,0.512,0.725,0.759l1.354,1.32 c0.235,0.256,0.471,0.512,0.725,0.759l1.355,1.321c0.235,0.256,0.471,0.511,0.724,0.758l1.353,1.319 c0.236,0.256,0.472,0.512,0.726,0.76l1.354,1.32c0.235,0.256,0.471,0.512,0.725,0.759l1.355,1.321 c0.235,0.256,0.471,0.511,0.724,0.758l0.352,0.343c2.572,3.799,3.624,8.482,2.833,13.094L200.663,418.093z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 195.511,
    x2: 254.8086,
    y2: 109.281,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M337.836,358.965c-20.841,21.126-49.814,34.207-81.836,34.207s-60.993-13.081-81.836-34.207 c8.329-37.527,41.797-65.576,81.836-65.576c23.154,0,44.11,9.392,59.277,24.559C326.343,329,334.331,343.146,337.836,358.965z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.1899,
    y1: 119.8624,
    x2: 173.6999,
    y2: 242.3424,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M323.244,340.878l-14.757-2.144l-38.848-38.762c-7.985-9.441-23.843-8.197-29.738,3.747 l-11.627,23.561c-2.615,5.299-7.67,8.971-13.517,9.82l-26.001,3.778c-4.518,0.657-8.197,2.819-10.828,5.795 c-1.551,3.962-2.825,8.063-3.764,12.292c20.841,21.126,49.814,34.207,81.836,34.207s60.993-13.081,81.836-34.207 c-0.933-4.209-2.192-8.295-3.733-12.241C331.47,343.724,327.784,341.537,323.244,340.878z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.8672,
    y1: 153.6997,
    x2: 268.7273,
    y2: 117.8397,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M272.099,303.719l11.627,23.561c2.615,5.299,7.67,8.971,13.517,9.82l26.001,3.778 c14.725,2.139,20.604,20.235,9.95,30.621l-18.814,18.34c-4.232,4.124-6.162,10.066-5.163,15.89l4.441,25.895 c2.515,14.665-12.877,25.849-26.048,18.925l-23.256-12.226c-5.23-2.75-11.478-2.75-16.708,0l-23.256,12.226 c-13.17,6.924-28.564-4.26-26.048-18.925l4.441-25.895c0.999-5.824-0.932-11.766-5.163-15.89l-18.814-18.34 c-10.655-10.386-4.776-28.481,9.95-30.621l26.001-3.778c5.847-0.849,10.902-4.522,13.517-9.82l11.627-23.561 C246.487,290.375,265.513,290.375,272.099,303.719z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.17,
    y1: 85.2524,
    x2: 214.09,
    y2: 176.3424,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M266.48,327.963l7.57,15.337c1.703,3.449,4.992,5.84,8.799,6.393l16.926,2.46 c9.585,1.392,13.412,13.172,6.476,19.933l-12.248,11.939c-2.755,2.685-4.012,6.553-3.361,10.344l2.891,16.857 c1.637,9.546-8.383,16.827-16.956,12.319l-15.139-7.959c-3.404-1.79-7.472-1.79-10.876,0l-15.139,7.959 c-8.573,4.508-18.594-2.773-16.956-12.319l2.891-16.857c0.651-3.791-0.606-7.659-3.361-10.344l-12.248-11.939 c-6.936-6.761-3.109-18.54,6.476-19.933l16.926-2.46c3.807-0.553,7.097-2.944,8.799-6.393l7.57-15.337 C249.807,319.277,262.193,319.277,266.48,327.963z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9485,
    y1: 149.181,
    x2: 281.2985,
    y2: 110.831,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    d: "M263.999,338.665l5.778,11.707c1.299,2.632,3.811,4.457,6.716,4.88l12.919,1.877 c7.317,1.063,10.238,10.054,4.943,15.215l-9.349,9.113c-2.102,2.049-3.062,5.002-2.565,7.896l2.207,12.867 c1.25,7.287-6.399,12.844-12.943,9.404l-11.556-6.075c-2.599-1.366-5.703-1.366-8.302,0l-11.556,6.075 c-6.545,3.44-14.192-2.116-12.944-9.404l2.207-12.867c0.496-2.893-0.463-5.847-2.565-7.896l-9.349-9.113 c-5.295-5.161-2.373-14.152,4.943-15.215l12.919-1.877c2.905-0.423,5.417-2.247,6.716-4.88l5.778-11.707 C251.273,332.035,260.728,332.035,263.999,338.665z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriority);
export default __webpack_public_path__ + "static/media/icon-priority.58601ea241c1973526087118d95b2a4d.svg";
export { ForwardRef as ReactComponent };